'use strict';
const svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	writeArrows = (pathInfo, g) => {
		if (pathInfo.arrows && pathInfo.arrows.length) {
			//connection.arrow can be true, 'to', 'from', 'both'
			pathInfo.arrows.forEach((arrow) => {
				svgMarkupBuilder('path').appendTo(g).attr({
					d: arrow,
					fill: pathInfo.lineProps.color,
					stroke: pathInfo.lineProps.color,
					'stroke-width': pathInfo.lineProps.width
				});
			});
		}
	};
module.exports = function writeLink(pathInfo) {
	const g = svgMarkupBuilder('g').attr('transform', 'translate(' + pathInfo.position.left + ',' + pathInfo.position.top + ')');

	svgMarkupBuilder('path').appendTo(g).attr({
		'd': pathInfo.d,
		'stroke-dasharray': pathInfo.lineProps.strokes,
		'stroke': pathInfo.lineProps.color,
		'stroke-width': pathInfo.lineProps.width,
		'stroke-linecap': pathInfo.lineProps.linecap
	});
	writeArrows(pathInfo, g);
	return g;
};


